import React from "react";

import { styled } from "@mui/material/styles";

interface FlagIconProps {
  countryCode: string;
  size?: "xss" | "xs" | "s" | "m" | "lg" | "xxl";
  customStyles?: React.CSSProperties;
  predefinedSRC?: string;
}

const Icon = styled("img", { shouldForwardProp: (prop) => prop !== "size" })<{
  size: "xss" | "xs" | "s" | "m" | "lg" | "xxl";
}>({}, ({ size }) => ({
  ...(size === "xss" && { width: "20px", height: "20px" }),
  ...(size === "xs" && { width: "30px", height: "30px" }),
  ...(size === "s" && { width: "50px", height: "50px" }),
  ...(size === "m" && { width: "70px", height: "70px" }),
  ...(size === "lg" && { width: "100px", height: "100px" }),
  ...(size === "xxl" && { width: "150px", height: "150px" }),
}));

const FlagIcon = ({ countryCode, size = "xs", customStyles, predefinedSRC }: FlagIconProps) => {
  return (
    <Icon
      alt=""
      size={size}
      src={
        predefinedSRC ??
        `https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.5/flags/4x3/${countryCode?.toLowerCase()}.svg`
      }
      style={!!customStyles ? customStyles : {}}
    />
  );
};

export default FlagIcon;
